export default __webpack_public_path__ + "static/media/gmail.799a5a01.png";